export default __webpack_public_path__ + "static/montague-county-eb0cc7cb7b342f573ef23d06109d0cdb.png";